<template>
  <v-row justify="center">
    <v-dialog v-model="isActive" max-width="800px" persistent scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ model.id ? "Editar" : "Crear" }} Actividad
          </span>
        </v-card-title>
        <v-card-text>
          <validation-observer ref="form">
            <v-container >
              <div class="row">
                <div class="col-12 mb-0 pb-0">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Nombre Item"
                    vid="name"
                    rules="required|max:100"
                  >
                    <v-text-field
                      v-model="model.name"
                      type="text"
                      outlined
                      dense
                      :error-messages="errors"
                      label="Nombre Item"
                      required
                    />
                  </validation-provider>
                </div>
              </div>
              <div v-for="(item, index) in model.hours" class="row" :key="index">
                <div class="col-5 my-0 py-0">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Hora Inicial"
                    vid="initialHour"
                    rules="required"
                  >
                    <v-select
                      :items="times"
                      v-model="item.initialHour"
                      item-text="description"
                      item-value="time"
                      outlined
                      dense
                      :error-messages="errors"
                      label="Hora Inicial"
                      required
                    />
                  </validation-provider>
                </div>
                <div class="col-5 my-0 py-0">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Hora Final"
                    vid="finalHour"
                    rules="required"
                  >
                    <v-select
                      :items="times"
                      v-model="item.finalHour"
                      item-text="description"
                      item-value="time"
                      outlined
                      dense
                      :error-messages="errors"
                      label="Hora Final"
                      required
                    />
                  </validation-provider>
                </div>
                <div class="col-2 my-0 py-0" v-if="model.hours.length > 1">
                  <v-btn
                    color="black"
                    class="text--primary text-none elevation-0"
                    @click="deleteDateRow(index)"
                  >
                    <v-icon color="white">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-0 pt-0">
                  <v-btn
                    color="secondary"
                    class="white--text text-none elevation-0"
                    @click="addDateRow"
                    dark>
                    Agregar
                  </v-btn>
                </div>
              </div>
            </v-container>
          </validation-observer>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="saveItem">
            Aceptar
          </v-btn>
          <v-btn color="red" text @click="close">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import crudServiceMobileMixin from '@/mixins/crudServiceMobileMixin'
import loaderMixin from '@/mixins/loaderMixin'
import notificationMixin from '@/mixins/notificationMixin'
import dateTimeMixin from '@/mixins/dateTimeMixin'

export default {
  name: 'FirstSectionModal',
  props: {
    order: {
      type: Number,
      default: null
    },
    fairId: {
      type: Number,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    url: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isActive: false,
      model: {
        id: null,
        name: null,
        order: null,
        isActive: null,
        hours: [
          {
            initialHour: null,
            finalHour: null
          }
        ]
      }
    }
  },
  methods: {
    addDateRow () {
      this.model.hours.push(
        {
          initialHour: null,
          finalHour: null
        }
      )
    },
    deleteDateRow (index) {
      this.model.hours.splice(index, 1)
    },
    close () {
      this.isActive = false
      this.clean()
    },
    clean () {
      this.$refs.form.reset()
      this.model = {
        name: null,
        hours: [
          {
            initialHour: null,
            finalHour: null
          }
        ]
      }
    },
    open (item) {
      if (item) {
        this.model.id = item.id
        this.model.name = item.name
        this.model.order = item.order
        this.model.isActive = item.isActive
        const hours = []
        if (item.hours?.length) {
          item.hours.forEach((elem) => {
            hours.push({
              initialHour: elem.initialHour,
              finalHour: elem.finalHour,
              id: elem.id
            })
          })
        }
        this.model.hours = hours
      }
      this.isActive = true
    },
    saveItem () {
      this.model.fairId = this.fairId
      this.$refs.form.validate().then((result) => {
        if (result) {
          if (this.model.id) {
            this.putMobile(this.url + '/' + this.model.id, this.model)
              .then((res) => {
                this.close()
                this.showSuccess(res.data.success)
                this.$emit('onClose')
              })
          } else {
            this.postMobile(this.url, this.model)
              .then((res) => {
                this.close()
                this.showSuccess(res.data.success)
                this.$emit('onClose')
              })
          }
        }
      })
    }
  },
  mixins: [
    crudServiceMobileMixin,
    notificationMixin,
    loaderMixin,
    dateTimeMixin
  ]
}
</script>
